var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"c-gallery"},_vm._l((_vm.items),function(item,i){return _c('div',{key:`gallery-${_vm._uid}-${i}`,staticClass:"c-gallery__item",style:(item.width ? `--width: ${item.width}%` : false)},[_vm._t("item",null,null,item)],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }